/**
 * Os raios perto de um foco nas horas antes dele, para a ficha e a denúncia:
 * uma consulta pequena (~300 B) à máquina, feita quando a ficha abre, com a
 * camada de raios ligada ou não.
 */
import { useEffect, useState } from 'react';
import { BASE_RAIOS, buscarRaiosPerto, type RaiosPerto } from './api';

/** A caixa que a máquina guarda (a América do Sul ao norte de 25°S). */
export function dentroDosRaios(lat: number, lon: number): boolean {
  return lat >= -25 && lat <= 15 && lon >= -85 && lon <= -30;
}

/** null enquanto carrega, fora da área ou se a consulta falhar (a ficha não mostra nada). */
export function useRaiosDoFoco(lat: number, lon: number, t: number): RaiosPerto | null {
  const [r, setR] = useState<RaiosPerto | null>(null);
  useEffect(() => {
    setR(null);
    if (!BASE_RAIOS || !dentroDosRaios(lat, lon)) return;
    let vivo = true;
    buscarRaiosPerto(lat, lon, t).then(
      (x) => vivo && setR(x),
      () => {},
    );
    return () => {
      vivo = false;
    };
  }, [lat, lon, t]);
  return r;
}
